import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import LazyImg from "../Library/LazyImage";
import LazyVideo from "../Library/LazyVideo";
import jeansImgW from "../../img/jeans.png";
import jeansImg from "../../img/DirectOrder.jpg";
import direct_order_image from "../../img/direct_order_image.jpg";

interface Props {}

export const DirectOrderCarousel = ( bannerInfo : any) => {
  const responsive = {
    0: { items: 1 },
    1024: { items: 1 },
  };
  console.log(bannerInfo.type)
  const items = [
   <LazyImg src={process.env.REACT_APP_STORAGE_URL+bannerInfo.directContent?.media} />,

  ];
  const itemsCreativeTeam = [
    <div className="video_wrapper">
      <LazyVideo
        id="videoBGCreativeStation"
        webkit-playsinline="true"
        autoPlay={true}
        preload="metadata"
        muted={true}
        loop
        playsInline={true}
        src={`${process.env.REACT_APP_STORAGE_URL}${bannerInfo.directContent?.media}`}
      />
    </div>,

  ];
   const isVideo = bannerInfo.directContent?.media?.endsWith('.mp4') || bannerInfo.directContent?.media?.endsWith('.webm');
  return (
      <AliceCarousel
          autoPlay={true}
          autoPlayInterval={50000}
          infinite={true}
          disableButtonsControls={true}
          items={isVideo ? itemsCreativeTeam : items} 
        disableDotsControls={true}
          responsive={responsive}
      />
  );
};
